import React, { useState } from "react";
import { Link } from "react-router-dom";
import SEO from "../components/SEO";
import { useContactDrawer } from "../context/ContactDrawerContext";

export default function AndreOpgaver() {
  const { openDrawer } = useContactDrawer();
  const [lightboxImage, setLightboxImage] = useState(null);

  const images = [
    {
      src: "https://assets.auxodev.dk/assets/77df7d82-25aa-453c-8f7b-e2453151bb33/645a442217253_1503c6ee.jpeg",
      alt: "Have og anlæg opgave"
    },
    {
      src: "https://assets.auxodev.dk/assets/77df7d82-25aa-453c-8f7b-e2453151bb33/645a442232287.jpeg",
      alt: "Have og anlægsarbejde"
    }
  ];

  return (
    <div className="pt-[72px] bg-brand-sand-50 min-h-screen">
      <SEO
        title="Andre opgaver | Elmegaarden Have og Anlæg"
        description="Vi kan lave alt inden for have og anlæg. Du er velkommen til at ringe til os og få et tilbud."
        canonical="/andre-opgaver"
      />

      {/* Header Banner */}
      <section className="bg-brand-green-950 text-white pt-24 pb-16">
        <div className="max-w-7xl mx-auto px-6">
          <div className="max-w-3xl text-left">
            <Link
              to="/opgaver"
              className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-wider text-brand-sand-300 hover:text-white mb-6 transition-colors"
            >
              <i className="fa-solid fa-arrow-left text-[10px]" /> Alle opgaver
            </Link>
            <h1 className="font-display text-4xl md:text-5xl font-bold text-white mb-4">
              Andre opgaver
            </h1>
            <p className="text-neutral-300 text-base md:text-lg leading-relaxed">
              Vi kan lave alt inden for have og anlæg. Du er velkommen til at ringe til os og få et tilbud.
            </p>
          </div>
        </div>
      </section>

      {/* Content */}
      <section className="py-16 md:py-24">
        <div className="max-w-7xl mx-auto px-6 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
          <div className="lg:col-span-8 flex flex-col gap-8 text-left">
            <p className="text-lg text-brand-charcoal/90 leading-relaxed font-medium">
              Vi kan lave alt inden for have og anlæg. Du er velkommen til at ringe til os og få et tilbud.
            </p>

            <div className="flex flex-wrap gap-4 pt-4 border-t border-brand-sand-200">
              <button
                onClick={openDrawer}
                className="px-6 py-3.5 bg-[#7ca632] hover:bg-[#6b9128] text-white font-bold text-xs sm:text-sm tracking-wide uppercase rounded-sm transition-all duration-300 shadow-sm cursor-pointer"
              >
                Kontakt os i dag
              </button>
              <a
                href="tel:+4520661517"
                className="px-6 py-3.5 bg-brand-green-900 hover:bg-brand-green-800 text-white font-bold text-xs sm:text-sm tracking-wide uppercase rounded-sm transition-all duration-300 shadow-sm flex items-center gap-2"
              >
                <i className="fa-solid fa-phone" /> Ring til os: 20 66 15 17
              </a>
            </div>

            {/* Images */}
            <div className="mt-8 pt-8 border-t border-brand-sand-200">
              <h2 className="font-display text-2xl font-bold text-brand-green-900 mb-6">
                Billeder
              </h2>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                {images.map((img, idx) => (
                  <div
                    key={idx}
                    onClick={() => setLightboxImage(img.src)}
                    className="group aspect-square rounded-sm overflow-hidden bg-neutral-100 border border-brand-sand-200 shadow-xs hover:shadow-md transition-all duration-300 cursor-pointer relative"
                  >
                    <img
                      src={img.src.replace(
                        "https://assets.auxodev.dk/assets/",
                        "https://assets.auxodev.dk/cdn-cgi/image/width=600,height=600,fit=cover,quality=80,format=auto/assets/"
                      )}
                      alt={img.alt}
                      className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                      loading="lazy"
                    />
                    <div className="absolute inset-0 bg-black/30 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
                      <i className="fa-solid fa-magnifying-glass-plus text-white text-xl" />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Sidebar */}
          <div className="lg:col-span-4 flex flex-col gap-8 text-left">
            <div className="bg-brand-green-900 text-white p-8 rounded-sm shadow-md">
              <h3 className="font-display text-xl font-bold text-white mb-4">
                Har du en forespørgsel?
              </h3>
              <p className="text-sm text-neutral-200 leading-relaxed mb-6">
                Vi rådgiver og hjælper med enhver haveopgave i Hobro, Arden, Hadsund og omegn.
              </p>
              <div className="flex flex-col gap-3 text-sm border-t border-white/10 pt-4">
                <div className="flex items-center gap-3">
                  <i className="fa-solid fa-phone text-[#7ca632]" />
                  <a href="tel:+4520661517" className="font-bold hover:text-[#7ca632] transition-colors">
                    +45 20 66 15 17
                  </a>
                </div>
                <div className="flex items-center gap-3">
                  <i className="fa-solid fa-envelope text-[#7ca632]" />
                  <a href="mailto:rasmus@elmegaardenhaveoganlaeg.dk" className="hover:text-[#7ca632] transition-colors break-all">
                    rasmus@elmegaardenhaveoganlaeg.dk
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Lightbox Modal */}
      {lightboxImage && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/95 backdrop-blur-sm transition-opacity duration-300 p-4"
          onClick={() => setLightboxImage(null)}
        >
          <button
            onClick={() => setLightboxImage(null)}
            className="absolute top-6 right-6 text-white hover:text-brand-sand-300 text-2xl p-2 cursor-pointer z-50"
            aria-label="Luk billede"
          >
            <i className="fa-solid fa-xmark" />
          </button>
          <div
            className="max-w-5xl max-h-[85vh] flex items-center justify-center"
            onClick={(e) => e.stopPropagation()}
          >
            <img
              src={lightboxImage.replace(
                "https://assets.auxodev.dk/assets/",
                "https://assets.auxodev.dk/cdn-cgi/image/width=1600,quality=90,format=auto/assets/"
              )}
              alt="Forstørret billede"
              className="max-w-full max-h-[75vh] object-contain rounded-sm shadow-2xl"
            />
          </div>
        </div>
      )}
    </div>
  );
}
